import { render, staticRenderFns } from "./printshare.vue?vue&type=template&id=2e6c9cd3"
import script from "./printshare.vue?vue&type=script&lang=js"
export * from "./printshare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports